module.exports = __webpack_public_path__ + "img/video_icon.6725ca4e.png";